import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 12px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
`;

export const ProgressWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  max-width: 840px;
  justify-content: center;
  gap: 20px;
`;

export const NumbersWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  max-width: 840px;
  justify-content: flex-start;
`;

export const CountWrapper = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
